import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./vendor.actions";
import { getters } from "./vendor.getters";
import { mutations } from "./vendor.mutations";
import { state } from "./vendor.state";
import { VendorState } from "./vendor.types";

const namespaced: boolean = true;
export const VendorModule: Module<VendorState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
